import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { literalConstant } from '../../shared/constant/literal.constant';
import { OperatorModel } from '../../shared/models/partial-cj/operator';
import { PostPartialCJModel } from '../../shared/models/partial-cj/post-partial-cj';

@Injectable({
  providedIn: 'root'
})
export class PartialCjService {
  constructor(
    private http: HttpClient,
    @Inject(literalConstant.API_URL) private baseUrl: string
  ) {}

  public savePartialCJContractDetails(request: PostPartialCJModel) {
    const url: string = this.baseUrl + 'PartialCJ/SavePartialCJContractDetails';
    return this.http.post(url, request);
  }

  getOperators(): Observable<OperatorModel[]> {
    return this.http.get<OperatorModel[]>(this.baseUrl + 'partialCJ/getOperators');
  }
}
